var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavedSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20V20.7C19.3866 20.7 19.7 20.3866 19.7 20H19ZM5 20H4.3C4.3 20.3866 4.6134 20.7 5 20.7V20ZM14 3L14.495 2.50503C14.3637 2.37375 14.1857 2.3 14 2.3V3ZM19 8H19.7C19.7 7.81435 19.6263 7.6363 19.495 7.50503L19 8ZM11.005 13.995C11.2784 14.2683 11.7216 14.2683 11.995 13.995C12.2683 13.7216 12.2683 13.2784 11.995 13.005L11.005 13.995ZM19 19.3H5V20.7H19V19.3ZM18.3 8V20H19.7V8H18.3ZM13.505 3.49497L18.505 8.49497L19.495 7.50503L14.495 2.50503L13.505 3.49497ZM8.50503 11.495L11.005 13.995L11.995 13.005L9.49497 10.505L8.50503 11.495ZM11 3.7H14V2.3H11V3.7ZM5.7 20V15H4.3V20H5.7Z",
    fill: "#2F3139"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 8.02487C10.8 10.3997 8.87482 12.3249 6.5 12.3249C4.12518 12.3249 2.2 10.3997 2.2 8.02487C2.2 5.65005 4.12518 3.72487 6.5 3.72487C8.87482 3.72487 10.8 5.65005 10.8 8.02487Z",
    stroke: "#2F3139",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedSearch);
export default __webpack_public_path__ + "static/media/saved-search.fa6f77ac3e9f118cd8ef299ce1a52f6b.svg";
export { ForwardRef as ReactComponent };